import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpGptGenerate {
}
ApiSmpGptGenerate.generate = (params, signal) => apiRequest({
    body: Object.assign({ model: "gpt-image-1", quality: "auto" }, params),
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/generate",
    method: "POST",
    signal,
});
//# sourceMappingURL=generate.js.map